import classNames from 'classnames'
import React, {memo, useRef} from 'react'

import {useBooleanQueryParam} from '../../../../../hooks/routes'
import {useIsStuck} from '../../../../../hooks/useIsStuck'

import EditPipelineToggle from './EditPipelineToggle/EditPipelineToggle'
import EditPipelineYamlActions from './EditPipelineYamlActions/EditPipelineYamlActions'
import EditPipelineYamlCounters from './EditPipelineYamlCounters/EditPipelineYamlCounters'

import styles from './EditPipelineToolbar.css'

type Props = {
  className?: string
}

function EditPipelineToolbar({className}: Props) {
  const isYaml = useBooleanQueryParam('yaml')

  const ref = useRef<HTMLDivElement>(null)
  const isStuck = useIsStuck(ref)

  return (
    <>
      <div className={styles.psevdoPanel} ref={ref} />
      <div className={classNames(className, styles.panel, {[styles.stuck]: isStuck})}>
        <EditPipelineToggle />
        {isYaml && <EditPipelineYamlActions />}
        {isYaml && <EditPipelineYamlCounters />}
      </div>
    </>
  )
}

export default memo<Props>(EditPipelineToolbar)
